/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ median: NonNullable<unknown>, average: NonNullable<unknown>, count: NonNullable<unknown> }} Statsroomgueststime3Inputs */

const en_statsroomgueststime3 = /** @type {(inputs: Statsroomgueststime3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Until the account: median ${i?.median} h, avg ${i?.average} h (${i?.count} measured)`)
};

const de_statsroomgueststime3 = /** @type {(inputs: Statsroomgueststime3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bis zum Konto: Median ${i?.median} Std., Ø ${i?.average} Std. (${i?.count} gemessen)`)
};

/**
* | output |
* | --- |
* | "Until the account: median {median} h, avg {average} h ({count} measured)" |
*
* @param {Statsroomgueststime3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsroomgueststime3 = /** @type {((inputs: Statsroomgueststime3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsroomgueststime3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsroomgueststime3(inputs)
	return de_statsroomgueststime3(inputs)
});
export { statsroomgueststime3 as "statsRoomGuestsTime" }